import { Modal } from "bootstrap";

// import ImageCarousel from "./image-carousel";
import AdoptionCarousel from "./adoption-carousel";
// import CoreFunctions from "./core-function";

// ImageCarousel();
AdoptionCarousel();
// CoreFunctions();